export const domain = {
  4: "Read",
  8: "Execute",
  16: "Change",
  32: "Add",
  64: "Remove",
  128: "Remove domain",
  256: "Edit shares"
};

export const source = {
  1: "Read",
  2: "Download",
  4: "Update",
  8: "Create",
  16: "Delete",
  32: "Owner"
};

export default { domain, source };
